module.exports = __webpack_public_path__ + "img/2x.dfb6581.jpg";